import theme from './theme.blue';
export default {
  "uniqueId": "kp01",
  "appName": "kp",
  "appColor": theme.primaryColor,
  "ownerName": "rock",
  "inboxType": "comments",
  "createdAt": "2019-06-02T06:48:00",
  "updatedAt": "2019-06-11T06:48:00",
  "messages": [{
    "uniqueId": 1,
    "status": "publish",
    "date": "2018-10-03T06:48:00",
    "author": {
      "name": "Arne Andersen",
      "email": "ivar.es@online.no"
    },
    "subject": "Message subject",
    "message": "Her er det en underlig prioritering av innholdet i bildet. Fatet er knapt synlig der det står på en hylle. Hovedmotivet er en sponhøvel, sponokse. En slik ble brukt til å høvle takspon, og ble kjørt over en stokk omtrent som en plog."
  }, {
    "uniqueId": 3,
    "status": "publish",
    "date": "2018-05-02T06:48:00",
    "author": {
      "name": "Ivar Stav",
      "email": "ivar.es@online.no"
    },
    "message": "Bilene fra venstre: Ford Taunus 17M 1958-60, SAAB, Moskwich 1954-55, Ford Zephyr Six 1951-53."
  }, {
    "uniqueId": 4,
    "status": "publish",
    "date": "2018-07-02T06:48:00",
    "author": {
      "name": "Ivar Stav",
      "email": "ivar.es@online.no"
    },
    "message": "Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Maecenas sed diam eget risus varius blandit sit amet non magna."
  }, {
    "uniqueId": 5,
    "status": "open",
    "date": "2018-08-11T06:48:00",
    "author": {
      "name": "Ivar Stav",
      "email": "ivar.es@online.no"
    },
    "message": "Vestibulum id ligula porta felis euismod semper. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras justo odio, dapibus ac facilisis in, egestas eget quam."
  }, {
    "uniqueId": 6,
    "status": "open",
    "date": "2018-09-12T06:48:00",
    "author": {
      "name": "Ivar Stav",
      "email": "ivar.es@online.no"
    },
    "message": "Donec ullamcorper nulla non metus auctor fringilla. Cras mattis consectetur purus sit amet fermentum."
  }, {
    "uniqueId": 2,
    "status": "open",
    "date": "2019-06-11T06:48:00",
    "author": {
      "name": "Espen Olavsson Hårseth",
      "email": "eo@online.no"
    },
    "message": "Hei, Enig i at dette ser rart ut! Årsaken er at fotoet er fra en tid da museet grupperte gjenstander for avfotografering under katalogiseringen. Dette ble gjort for å spare film. Grupperingsfotoene ble så klipt i biter, og klippet med skålen ble limt på katalogkortet for OF.4899-Fat, mens resten av bilde, som viser høvelen, har blitt limt på katalogkortet for denne. Dette er imidlertid av de mer særegne eksemplene jeg har sett. Stort sett er det gjenstander med et nærere slektskap, for eksempel en gruppe stoler, som er avbildet sammen. Vi har allikevel valgt å legge ut disse gamle bildene som en del av samlingshistorikken. En del gjenstander har fått nye fargefoto, men dette er et langt lerret å bleke. Vennlig hilsen Espen Olavsson Hårseth, konservator Anno Domkirkeodden."
  }]
};